import type { ThemeMode } from "@carbon6/c6-frontend-design";

/**
 * 라벨이 아닌 facet 축(Embodiment·End effector·Tip·팔 구성·카메라·수집 방식·에피소드 결함)의 칩 색이다.
 *
 * 카탈로그 라벨은 자기 색을 가진다. 이 축들은 색이 없다. 중립색(0=검정)으로 그리면 다크 테마에서
 * 칩 배경·점·글자가 같은 톤이 되어 구분되지 않는다. 그래서 축마다 색조를 하나 정한다. **라이트는
 * 어두운 단계(700), 다크는 밝은 단계(300)** 를 쓴다. 그래서 c6 LabelChip 의 12% 배경 위에서 점과
 * 글자가 구분된다. 값은 Tailwind 팔레트다(앱의 다른 리터럴 색과 같은 계열).
 */
const FACET_CHIP_COLORS: Readonly<Record<string, { light: number; dark: number }>> = {
  embodiment: { light: 0x1d4ed8, dark: 0x93c5fd }, // blue
  end_effector: { light: 0x0f766e, dark: 0x5eead4 }, // teal
  tip: { light: 0xb45309, dark: 0xfcd34d }, // amber
  arms: { light: 0x6d28d9, dark: 0xc4b5fd }, // violet
  camera_channel: { light: 0x0e7490, dark: 0x67e8f9 }, // cyan
  camera_count: { light: 0x0369a1, dark: 0x7dd3fc }, // sky
  recording_mode: { light: 0xbe123c, dark: 0xfda4af }, // rose
  // 값은 카탈로그 라벨(`quality:<tag>`)이라 색이 있다. 그러나 후보 키는 `episode_quality:<tag>` 라서
  // 이 표를 쓴다. tip 이 amber 를 쓰므로 옆 색조인 orange 로 구분한다.
  episode_quality: { light: 0xc2410c, dark: 0xfdba74 }, // orange
};

// 표에 없는 축의 색이다. 색조 없는 회색도 테마별로 명도는 다르게 둔다.
const NEUTRAL_CHIP_COLOR = { light: 0x374151, dark: 0xd1d5db };

export function facetChipColor(facetKey: string, mode: ThemeMode): number {
  return (FACET_CHIP_COLORS[facetKey] ?? NEUTRAL_CHIP_COLOR)[mode];
}
